import type {
  MemberListParams,
  RunItemListParams,
  RunListParams,
  ScheduleListParams,
  TimelineParams,
} from '../api/schedules-api';

/**
 * Organisation-level keys. Everything hangs off `['org', 'schedules']`, which other screens'
 * schedule lookups (the store catalog's schedule filter) share, so invalidating `all` after a
 * write refreshes them too.
 */
export const scheduleKeys = {
  all: ['org', 'schedules'] as const,
  lists: () => [...scheduleKeys.all, 'list'] as const,
  list: (params: ScheduleListParams) => [...scheduleKeys.lists(), params] as const,
  details: () => [...scheduleKeys.all, 'detail'] as const,
  detail: (id: string) => [...scheduleKeys.details(), id] as const,
  members: (id: string) => [...scheduleKeys.detail(id), 'members'] as const,
  memberList: (id: string, params: MemberListParams) =>
    [...scheduleKeys.members(id), params] as const,
  runs: (id: string) => [...scheduleKeys.detail(id), 'runs'] as const,
  runList: (id: string, params: RunListParams) =>
    [...scheduleKeys.runs(id), 'list', params] as const,
  run: (id: string, runId: string) => [...scheduleKeys.runs(id), 'run', runId] as const,
  runItems: (id: string, runId: string, params: RunItemListParams) =>
    [...scheduleKeys.run(id, runId), 'items', params] as const,
  timelines: () => [...scheduleKeys.all, 'timeline'] as const,
  timeline: (params: TimelineParams) => [...scheduleKeys.timelines(), params] as const,
  /** Master products (titles, handles) for ids handed over in the URL, read with `?ids=`. */
  productLookups: () => [...scheduleKeys.all, 'products-by-ids'] as const,
  productsByIds: (ids: readonly string[]) => [...scheduleKeys.productLookups(), ids] as const,
};
